import styles from './ReviewOrderList.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReviewOrderListItem } from './ReviewOrderListItem';

import bankIcon from 'src/images/icons/icon-bank.svg';
import createAccountIcon from 'src/images/icons/icon-create-account.svg';
import shippingIcon from 'src/images/icons/icon-shipping.svg';

export const reviewCircles = [
  {
    headingProps: `checkout-review.clover-account-creation`,
    descriptionProps: `checkout-review.clover-account-creation-description`,
    icon: createAccountIcon,
  },
  {
    headingProps: `checkout-review.apply-for-processing`,
    descriptionProps: `checkout-review.apply-for-processing-description`,
    icon: bankIcon,
  },
  {
    headingProps: `checkout-review.receive-POS-and-start-selling`,
    descriptionProps: `checkout-review.receive-POS-and-start-selling-description`,
    icon: shippingIcon,
  },
];

export const ReviewOrderList: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ul className={styles.reviewOrderList}>
      {reviewCircles.map(
        ({ headingProps, descriptionProps, icon }, index) => {
          return (
            <ReviewOrderListItem
              key={index}
              heading={t(headingProps as any)}
              description={t(descriptionProps as any)}
              icon={icon}
            />
          );
        }
      )}
    </ul>
  );
};
